import { Sparkles } from "lucide-react";
import Markdown from "markdown-to-jsx";
import React from "react";
import { ExpandableWidget } from "./ExpandableWidget";

interface IProps {
    title?: string;
    comparisonText: string;
    attribution?: string;
    defaultExpanded?: boolean;
    noWrapper?: boolean;
}

export const AiComparisonExpandableWidget: React.FC<IProps> = ({
    title = "AI Comparison",
    comparisonText,
    attribution,
    defaultExpanded = false,
    noWrapper = true,
}) => {
    return (
        <ExpandableWidget
            icon={<Sparkles style={{ width: 14, height: 14 }} />}
            title={title}
            attribution={attribution}
            accentColor={"#c4b5fd"}
            backgroundColor={"#faf5ff"}
            textColor={"#7c3aed"}
            defaultExpanded={defaultExpanded}
            noWrapper={noWrapper}
            expandable={comparisonText.trim().length > 0}
        >
            <Markdown>{comparisonText}</Markdown>
        </ExpandableWidget>
    );
};

// Keep the old export name for backwards compatibility
export const ExpandableAiComparison = AiComparisonExpandableWidget;
